export default __webpack_public_path__ + "static/media/Logo-primary.a502d6e6.svg";